import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInt: any;
  Bytes: any;
};

/**
 * A bidder participating in an auction
 *
 */
export type Account = {
  /** List of Bid objects */
  bids?: Maybe<Array<Bid>>;
  /** Address of the account */
  id: Scalars['ID'];
  /** List of TokenBalance objects */
  tokenBalances?: Maybe<Array<TokenBalance>>;
  /** User ID assigned by Gnosis Auction contract */
  userid?: Maybe<Scalars['String']>;
};


/**
 * A bidder participating in an auction
 *
 */
export type AccountBidsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Bid_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Bid_Filter>;
};


/**
 * A bidder participating in an auction
 *
 */
export type AccountTokenBalancesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TokenBalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TokenBalance_Filter>;
};

export type Account_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Account_Filter>>>;
  bids_?: InputMaybe<Bid_Filter>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<Account_Filter>>>;
  tokenBalances_?: InputMaybe<TokenBalance_Filter>;
  userid?: InputMaybe<Scalars['String']>;
  userid_contains?: InputMaybe<Scalars['String']>;
  userid_contains_nocase?: InputMaybe<Scalars['String']>;
  userid_ends_with?: InputMaybe<Scalars['String']>;
  userid_ends_with_nocase?: InputMaybe<Scalars['String']>;
  userid_gt?: InputMaybe<Scalars['String']>;
  userid_gte?: InputMaybe<Scalars['String']>;
  userid_in?: InputMaybe<Array<Scalars['String']>>;
  userid_lt?: InputMaybe<Scalars['String']>;
  userid_lte?: InputMaybe<Scalars['String']>;
  userid_not?: InputMaybe<Scalars['String']>;
  userid_not_contains?: InputMaybe<Scalars['String']>;
  userid_not_contains_nocase?: InputMaybe<Scalars['String']>;
  userid_not_ends_with?: InputMaybe<Scalars['String']>;
  userid_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  userid_not_in?: InputMaybe<Array<Scalars['String']>>;
  userid_not_starts_with?: InputMaybe<Scalars['String']>;
  userid_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  userid_starts_with?: InputMaybe<Scalars['String']>;
  userid_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum Account_OrderBy {
  Bids = 'bids',
  Id = 'id',
  TokenBalances = 'tokenBalances',
  Userid = 'userid'
}

/**
 * An instance of a started Gnosis auction
 *
 */
export type Auction = {
  /** Object reference to an ERC20 Token */
  bidding: Token;
  /** Object reference to a Bond */
  bond: Bond;
  /** Quantity of sold bonds */
  bondsSold: Scalars['BigInt'];
  /** Price that each bond was sold at denominated in paymentTokens */
  clearingPrice?: Maybe<Scalars['BigDecimal']>;
  /** Auction end timestamp */
  end: Scalars['BigInt'];
  /** Gnosis Auction ID */
  id: Scalars['ID'];
  /** If the auction is currently ongoing, or if it has ended */
  live: Scalars['Boolean'];
  /** Minimum amount of paymentTokens in a single bid */
  minimumBidSize: Scalars['BigInt'];
  /** Minimum paymentToken per bond */
  minimumBondPrice: Scalars['BigDecimal'];
  /** Minimum amount of payment tokens to buy for a successful auction */
  minimumFundingThreshold: Scalars['BigInt'];
  /** Total number of bonds to be auctioned */
  offeringSize: Scalars['BigInt'];
  /** Final date that bids can be canceled */
  orderCancellationEndDate: Scalars['BigInt'];
  /** Auction start timestamp */
  start: Scalars['BigInt'];
  /** Total number of current bids */
  totalBidVolume: Scalars['BigInt'];
  /** Quantity of sold payment tokens */
  totalPaid?: Maybe<Scalars['BigInt']>;
};

export type Auction_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Auction_Filter>>>;
  bidding?: InputMaybe<Scalars['String']>;
  bidding_?: InputMaybe<Token_Filter>;
  bidding_contains?: InputMaybe<Scalars['String']>;
  bidding_contains_nocase?: InputMaybe<Scalars['String']>;
  bidding_ends_with?: InputMaybe<Scalars['String']>;
  bidding_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bidding_gt?: InputMaybe<Scalars['String']>;
  bidding_gte?: InputMaybe<Scalars['String']>;
  bidding_in?: InputMaybe<Array<Scalars['String']>>;
  bidding_lt?: InputMaybe<Scalars['String']>;
  bidding_lte?: InputMaybe<Scalars['String']>;
  bidding_not?: InputMaybe<Scalars['String']>;
  bidding_not_contains?: InputMaybe<Scalars['String']>;
  bidding_not_contains_nocase?: InputMaybe<Scalars['String']>;
  bidding_not_ends_with?: InputMaybe<Scalars['String']>;
  bidding_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bidding_not_in?: InputMaybe<Array<Scalars['String']>>;
  bidding_not_starts_with?: InputMaybe<Scalars['String']>;
  bidding_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bidding_starts_with?: InputMaybe<Scalars['String']>;
  bidding_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bond?: InputMaybe<Scalars['String']>;
  bond_?: InputMaybe<Bond_Filter>;
  bond_contains?: InputMaybe<Scalars['String']>;
  bond_contains_nocase?: InputMaybe<Scalars['String']>;
  bond_ends_with?: InputMaybe<Scalars['String']>;
  bond_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bond_gt?: InputMaybe<Scalars['String']>;
  bond_gte?: InputMaybe<Scalars['String']>;
  bond_in?: InputMaybe<Array<Scalars['String']>>;
  bond_lt?: InputMaybe<Scalars['String']>;
  bond_lte?: InputMaybe<Scalars['String']>;
  bond_not?: InputMaybe<Scalars['String']>;
  bond_not_contains?: InputMaybe<Scalars['String']>;
  bond_not_contains_nocase?: InputMaybe<Scalars['String']>;
  bond_not_ends_with?: InputMaybe<Scalars['String']>;
  bond_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bond_not_in?: InputMaybe<Array<Scalars['String']>>;
  bond_not_starts_with?: InputMaybe<Scalars['String']>;
  bond_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bond_starts_with?: InputMaybe<Scalars['String']>;
  bond_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bondsSold?: InputMaybe<Scalars['BigInt']>;
  bondsSold_gt?: InputMaybe<Scalars['BigInt']>;
  bondsSold_gte?: InputMaybe<Scalars['BigInt']>;
  bondsSold_in?: InputMaybe<Array<Scalars['BigInt']>>;
  bondsSold_lt?: InputMaybe<Scalars['BigInt']>;
  bondsSold_lte?: InputMaybe<Scalars['BigInt']>;
  bondsSold_not?: InputMaybe<Scalars['BigInt']>;
  bondsSold_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  clearingPrice?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_gt?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_gte?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  clearingPrice_lt?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_lte?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_not?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  end?: InputMaybe<Scalars['BigInt']>;
  end_gt?: InputMaybe<Scalars['BigInt']>;
  end_gte?: InputMaybe<Scalars['BigInt']>;
  end_in?: InputMaybe<Array<Scalars['BigInt']>>;
  end_lt?: InputMaybe<Scalars['BigInt']>;
  end_lte?: InputMaybe<Scalars['BigInt']>;
  end_not?: InputMaybe<Scalars['BigInt']>;
  end_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  live?: InputMaybe<Scalars['Boolean']>;
  live_in?: InputMaybe<Array<Scalars['Boolean']>>;
  live_not?: InputMaybe<Scalars['Boolean']>;
  live_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  minimumBidSize?: InputMaybe<Scalars['BigInt']>;
  minimumBidSize_gt?: InputMaybe<Scalars['BigInt']>;
  minimumBidSize_gte?: InputMaybe<Scalars['BigInt']>;
  minimumBidSize_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumBidSize_lt?: InputMaybe<Scalars['BigInt']>;
  minimumBidSize_lte?: InputMaybe<Scalars['BigInt']>;
  minimumBidSize_not?: InputMaybe<Scalars['BigInt']>;
  minimumBidSize_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumBondPrice?: InputMaybe<Scalars['BigDecimal']>;
  minimumBondPrice_gt?: InputMaybe<Scalars['BigDecimal']>;
  minimumBondPrice_gte?: InputMaybe<Scalars['BigDecimal']>;
  minimumBondPrice_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  minimumBondPrice_lt?: InputMaybe<Scalars['BigDecimal']>;
  minimumBondPrice_lte?: InputMaybe<Scalars['BigDecimal']>;
  minimumBondPrice_not?: InputMaybe<Scalars['BigDecimal']>;
  minimumBondPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  minimumFundingThreshold?: InputMaybe<Scalars['BigInt']>;
  minimumFundingThreshold_gt?: InputMaybe<Scalars['BigInt']>;
  minimumFundingThreshold_gte?: InputMaybe<Scalars['BigInt']>;
  minimumFundingThreshold_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumFundingThreshold_lt?: InputMaybe<Scalars['BigInt']>;
  minimumFundingThreshold_lte?: InputMaybe<Scalars['BigInt']>;
  minimumFundingThreshold_not?: InputMaybe<Scalars['BigInt']>;
  minimumFundingThreshold_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  offeringSize?: InputMaybe<Scalars['BigInt']>;
  offeringSize_gt?: InputMaybe<Scalars['BigInt']>;
  offeringSize_gte?: InputMaybe<Scalars['BigInt']>;
  offeringSize_in?: InputMaybe<Array<Scalars['BigInt']>>;
  offeringSize_lt?: InputMaybe<Scalars['BigInt']>;
  offeringSize_lte?: InputMaybe<Scalars['BigInt']>;
  offeringSize_not?: InputMaybe<Scalars['BigInt']>;
  offeringSize_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<Auction_Filter>>>;
  orderCancellationEndDate?: InputMaybe<Scalars['BigInt']>;
  orderCancellationEndDate_gt?: InputMaybe<Scalars['BigInt']>;
  orderCancellationEndDate_gte?: InputMaybe<Scalars['BigInt']>;
  orderCancellationEndDate_in?: InputMaybe<Array<Scalars['BigInt']>>;
  orderCancellationEndDate_lt?: InputMaybe<Scalars['BigInt']>;
  orderCancellationEndDate_lte?: InputMaybe<Scalars['BigInt']>;
  orderCancellationEndDate_not?: InputMaybe<Scalars['BigInt']>;
  orderCancellationEndDate_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  start?: InputMaybe<Scalars['BigInt']>;
  start_gt?: InputMaybe<Scalars['BigInt']>;
  start_gte?: InputMaybe<Scalars['BigInt']>;
  start_in?: InputMaybe<Array<Scalars['BigInt']>>;
  start_lt?: InputMaybe<Scalars['BigInt']>;
  start_lte?: InputMaybe<Scalars['BigInt']>;
  start_not?: InputMaybe<Scalars['BigInt']>;
  start_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalBidVolume?: InputMaybe<Scalars['BigInt']>;
  totalBidVolume_gt?: InputMaybe<Scalars['BigInt']>;
  totalBidVolume_gte?: InputMaybe<Scalars['BigInt']>;
  totalBidVolume_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalBidVolume_lt?: InputMaybe<Scalars['BigInt']>;
  totalBidVolume_lte?: InputMaybe<Scalars['BigInt']>;
  totalBidVolume_not?: InputMaybe<Scalars['BigInt']>;
  totalBidVolume_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalPaid?: InputMaybe<Scalars['BigInt']>;
  totalPaid_gt?: InputMaybe<Scalars['BigInt']>;
  totalPaid_gte?: InputMaybe<Scalars['BigInt']>;
  totalPaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalPaid_lt?: InputMaybe<Scalars['BigInt']>;
  totalPaid_lte?: InputMaybe<Scalars['BigInt']>;
  totalPaid_not?: InputMaybe<Scalars['BigInt']>;
  totalPaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export enum Auction_OrderBy {
  Bidding = 'bidding',
  BiddingDecimals = 'bidding__decimals',
  BiddingId = 'bidding__id',
  BiddingName = 'bidding__name',
  BiddingSymbol = 'bidding__symbol',
  Bond = 'bond',
  BondAmountUnpaid = 'bond__amountUnpaid',
  BondClearingPrice = 'bond__clearingPrice',
  BondCollateralRatio = 'bond__collateralRatio',
  BondCollateralTokenAmount = 'bond__collateralTokenAmount',
  BondConvertibleRatio = 'bond__convertibleRatio',
  BondConvertibleTokenAmount = 'bond__convertibleTokenAmount',
  BondCreatedAt = 'bond__createdAt',
  BondDecimals = 'bond__decimals',
  BondId = 'bond__id',
  BondMaturityDate = 'bond__maturityDate',
  BondMaxSupply = 'bond__maxSupply',
  BondName = 'bond__name',
  BondOwner = 'bond__owner',
  BondState = 'bond__state',
  BondSymbol = 'bond__symbol',
  BondType = 'bond__type',
  BondsSold = 'bondsSold',
  ClearingPrice = 'clearingPrice',
  End = 'end',
  Id = 'id',
  Live = 'live',
  MinimumBidSize = 'minimumBidSize',
  MinimumBondPrice = 'minimumBondPrice',
  MinimumFundingThreshold = 'minimumFundingThreshold',
  OfferingSize = 'offeringSize',
  OrderCancellationEndDate = 'orderCancellationEndDate',
  Start = 'start',
  TotalBidVolume = 'totalBidVolume',
  TotalPaid = 'totalPaid'
}

/**
 * A bid on an auction
 *
 */
export type Bid = {
  /** Object reference to Account */
  account: Account;
  /** Gnosis Auction ID */
  auction: Scalars['Int'];
  /** Encoding of user ID, bid buy amount and bid sell amount */
  bytes: Scalars['String'];
  /** Transaction hash of bid cancellation */
  canceltx?: Maybe<Scalars['Bytes']>;
  /** Transaction hash of bid claim */
  claimtx?: Maybe<Scalars['Bytes']>;
  /** Transaction hash of bid creation */
  createtx: Scalars['Bytes'];
  /** Concatenation of Gnosis Auction ID, user ID, bid buy amount and bid sell amount */
  id: Scalars['ID'];
  /** Total amount of collateral paid by bidder */
  payable: Scalars['BigInt'];
  /** Quantity of bonds */
  size: Scalars['BigInt'];
  /** Bid timestamp */
  timestamp: Scalars['BigInt'];
};

export type Bid_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']>;
  account_contains_nocase?: InputMaybe<Scalars['String']>;
  account_ends_with?: InputMaybe<Scalars['String']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']>;
  account_gt?: InputMaybe<Scalars['String']>;
  account_gte?: InputMaybe<Scalars['String']>;
  account_in?: InputMaybe<Array<Scalars['String']>>;
  account_lt?: InputMaybe<Scalars['String']>;
  account_lte?: InputMaybe<Scalars['String']>;
  account_not?: InputMaybe<Scalars['String']>;
  account_not_contains?: InputMaybe<Scalars['String']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']>;
  account_not_ends_with?: InputMaybe<Scalars['String']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  account_not_in?: InputMaybe<Array<Scalars['String']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  account_starts_with?: InputMaybe<Scalars['String']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']>;
  and?: InputMaybe<Array<InputMaybe<Bid_Filter>>>;
  auction?: InputMaybe<Scalars['Int']>;
  auction_gt?: InputMaybe<Scalars['Int']>;
  auction_gte?: InputMaybe<Scalars['Int']>;
  auction_in?: InputMaybe<Array<Scalars['Int']>>;
  auction_lt?: InputMaybe<Scalars['Int']>;
  auction_lte?: InputMaybe<Scalars['Int']>;
  auction_not?: InputMaybe<Scalars['Int']>;
  auction_not_in?: InputMaybe<Array<Scalars['Int']>>;
  bytes?: InputMaybe<Scalars['String']>;
  bytes_contains?: InputMaybe<Scalars['String']>;
  bytes_contains_nocase?: InputMaybe<Scalars['String']>;
  bytes_ends_with?: InputMaybe<Scalars['String']>;
  bytes_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bytes_gt?: InputMaybe<Scalars['String']>;
  bytes_gte?: InputMaybe<Scalars['String']>;
  bytes_in?: InputMaybe<Array<Scalars['String']>>;
  bytes_lt?: InputMaybe<Scalars['String']>;
  bytes_lte?: InputMaybe<Scalars['String']>;
  bytes_not?: InputMaybe<Scalars['String']>;
  bytes_not_contains?: InputMaybe<Scalars['String']>;
  bytes_not_contains_nocase?: InputMaybe<Scalars['String']>;
  bytes_not_ends_with?: InputMaybe<Scalars['String']>;
  bytes_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bytes_not_in?: InputMaybe<Array<Scalars['String']>>;
  bytes_not_starts_with?: InputMaybe<Scalars['String']>;
  bytes_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bytes_starts_with?: InputMaybe<Scalars['String']>;
  bytes_starts_with_nocase?: InputMaybe<Scalars['String']>;
  canceltx?: InputMaybe<Scalars['Bytes']>;
  canceltx_contains?: InputMaybe<Scalars['Bytes']>;
  canceltx_gt?: InputMaybe<Scalars['Bytes']>;
  canceltx_gte?: InputMaybe<Scalars['Bytes']>;
  canceltx_in?: InputMaybe<Array<Scalars['Bytes']>>;
  canceltx_lt?: InputMaybe<Scalars['Bytes']>;
  canceltx_lte?: InputMaybe<Scalars['Bytes']>;
  canceltx_not?: InputMaybe<Scalars['Bytes']>;
  canceltx_not_contains?: InputMaybe<Scalars['Bytes']>;
  canceltx_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  claimtx?: InputMaybe<Scalars['Bytes']>;
  claimtx_contains?: InputMaybe<Scalars['Bytes']>;
  claimtx_gt?: InputMaybe<Scalars['Bytes']>;
  claimtx_gte?: InputMaybe<Scalars['Bytes']>;
  claimtx_in?: InputMaybe<Array<Scalars['Bytes']>>;
  claimtx_lt?: InputMaybe<Scalars['Bytes']>;
  claimtx_lte?: InputMaybe<Scalars['Bytes']>;
  claimtx_not?: InputMaybe<Scalars['Bytes']>;
  claimtx_not_contains?: InputMaybe<Scalars['Bytes']>;
  claimtx_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  createtx?: InputMaybe<Scalars['Bytes']>;
  createtx_contains?: InputMaybe<Scalars['Bytes']>;
  createtx_gt?: InputMaybe<Scalars['Bytes']>;
  createtx_gte?: InputMaybe<Scalars['Bytes']>;
  createtx_in?: InputMaybe<Array<Scalars['Bytes']>>;
  createtx_lt?: InputMaybe<Scalars['Bytes']>;
  createtx_lte?: InputMaybe<Scalars['Bytes']>;
  createtx_not?: InputMaybe<Scalars['Bytes']>;
  createtx_not_contains?: InputMaybe<Scalars['Bytes']>;
  createtx_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<Bid_Filter>>>;
  payable?: InputMaybe<Scalars['BigInt']>;
  payable_gt?: InputMaybe<Scalars['BigInt']>;
  payable_gte?: InputMaybe<Scalars['BigInt']>;
  payable_in?: InputMaybe<Array<Scalars['BigInt']>>;
  payable_lt?: InputMaybe<Scalars['BigInt']>;
  payable_lte?: InputMaybe<Scalars['BigInt']>;
  payable_not?: InputMaybe<Scalars['BigInt']>;
  payable_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  size?: InputMaybe<Scalars['BigInt']>;
  size_gt?: InputMaybe<Scalars['BigInt']>;
  size_gte?: InputMaybe<Scalars['BigInt']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']>>;
  size_lt?: InputMaybe<Scalars['BigInt']>;
  size_lte?: InputMaybe<Scalars['BigInt']>;
  size_not?: InputMaybe<Scalars['BigInt']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export enum Bid_OrderBy {
  Account = 'account',
  AccountId = 'account__id',
  AccountUserid = 'account__userid',
  Auction = 'auction',
  Bytes = 'bytes',
  Canceltx = 'canceltx',
  Claimtx = 'claimtx',
  Createtx = 'createtx',
  Id = 'id',
  Payable = 'payable',
  Size = 'size',
  Timestamp = 'timestamp'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']>;
  number?: InputMaybe<Scalars['Int']>;
  number_gte?: InputMaybe<Scalars['Int']>;
};

/**
 * A bond created by a bond factory
 *
 */
export type Bond = {
  /** Amount of paymentTokens unpaid relative to the bond supply */
  amountUnpaid: Scalars['BigInt'];
  /** Auctions in which this bond is the auctioning token */
  auctions: Array<Auction>;
  /** The price of the bond in paymentTokens from the latest auction */
  clearingPrice?: Maybe<Scalars['BigDecimal']>;
  /** Number of collateralTokens per bond */
  collateralRatio: Scalars['BigInt'];
  /** Token that is put up to collateralize the bond */
  collateralToken: Token;
  /** Total number of collateralTokens backing the bond */
  collateralTokenAmount: Scalars['BigInt'];
  /** Number of collateralTokens a bond can be converted into */
  convertibleRatio: Scalars['BigInt'];
  /** The total number of collateralTokens that are convertible */
  convertibleTokenAmount: Scalars['BigInt'];
  /** Block timestamp when the bond was created */
  createdAt: Scalars['BigInt'];
  /** ERC20 token decimals */
  decimals: Scalars['Int'];
  /** Address of the bond */
  id: Scalars['ID'];
  /** Timestamp at which the bond matures */
  maturityDate: Scalars['BigInt'];
  /** Total number of bonds */
  maxSupply: Scalars['BigInt'];
  /** ERC20 token name */
  name: Scalars['String'];
  /** Owner of the bond */
  owner: Scalars['Bytes'];
  /** Token that is being borrowed and will be paid */
  paymentToken: Token;
  /** Current state of the bond */
  state: BondState;
  /** ERC20 token symbol */
  symbol: Scalars['String'];
  /** Balances of bond holders */
  tokenBalances: Array<TokenBalance>;
  /** Type of bond, either simple or convert */
  type: BondType;
};


/**
 * A bond created by a bond factory
 *
 */
export type BondAuctionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Auction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Auction_Filter>;
};


/**
 * A bond created by a bond factory
 *
 */
export type BondTokenBalancesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TokenBalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TokenBalance_Filter>;
};

/**
 * An instance of an Arbor bond factory
 *
 */
export type BondFactory = {
  /** Total number of bonds created by this factory */
  bondCount: Scalars['BigInt'];
  /** List of bonds created by this factory */
  bonds?: Maybe<Array<Bond>>;
  /** Address of the bond factory */
  id: Scalars['ID'];
  /** Whether or not the allow list for issuers is enforced */
  isIssuerAllowListEnabled: Scalars['Boolean'];
  /** Whether or not the allow list for tokens is enforced */
  isTokenAllowListEnabled: Scalars['Boolean'];
  /** List of allowed issuers */
  issuerAllowList?: Maybe<Array<Scalars['Bytes']>>;
  /** List of allowed tokens used for payment or collateral */
  tokenAllowList?: Maybe<Array<Scalars['Bytes']>>;
};


/**
 * An instance of an Arbor bond factory
 *
 */
export type BondFactoryBondsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Bond_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Bond_Filter>;
};

export type BondFactory_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<BondFactory_Filter>>>;
  bondCount?: InputMaybe<Scalars['BigInt']>;
  bondCount_gt?: InputMaybe<Scalars['BigInt']>;
  bondCount_gte?: InputMaybe<Scalars['BigInt']>;
  bondCount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  bondCount_lt?: InputMaybe<Scalars['BigInt']>;
  bondCount_lte?: InputMaybe<Scalars['BigInt']>;
  bondCount_not?: InputMaybe<Scalars['BigInt']>;
  bondCount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  bonds?: InputMaybe<Array<Scalars['String']>>;
  bonds_?: InputMaybe<Bond_Filter>;
  bonds_contains?: InputMaybe<Array<Scalars['String']>>;
  bonds_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  bonds_not?: InputMaybe<Array<Scalars['String']>>;
  bonds_not_contains?: InputMaybe<Array<Scalars['String']>>;
  bonds_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  isIssuerAllowListEnabled?: InputMaybe<Scalars['Boolean']>;
  isIssuerAllowListEnabled_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isIssuerAllowListEnabled_not?: InputMaybe<Scalars['Boolean']>;
  isIssuerAllowListEnabled_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isTokenAllowListEnabled?: InputMaybe<Scalars['Boolean']>;
  isTokenAllowListEnabled_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isTokenAllowListEnabled_not?: InputMaybe<Scalars['Boolean']>;
  isTokenAllowListEnabled_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  issuerAllowList?: InputMaybe<Array<Scalars['Bytes']>>;
  issuerAllowList_contains?: InputMaybe<Array<Scalars['Bytes']>>;
  issuerAllowList_contains_nocase?: InputMaybe<Array<Scalars['Bytes']>>;
  issuerAllowList_not?: InputMaybe<Array<Scalars['Bytes']>>;
  issuerAllowList_not_contains?: InputMaybe<Array<Scalars['Bytes']>>;
  issuerAllowList_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']>>;
  or?: InputMaybe<Array<InputMaybe<BondFactory_Filter>>>;
  tokenAllowList?: InputMaybe<Array<Scalars['Bytes']>>;
  tokenAllowList_contains?: InputMaybe<Array<Scalars['Bytes']>>;
  tokenAllowList_contains_nocase?: InputMaybe<Array<Scalars['Bytes']>>;
  tokenAllowList_not?: InputMaybe<Array<Scalars['Bytes']>>;
  tokenAllowList_not_contains?: InputMaybe<Array<Scalars['Bytes']>>;
  tokenAllowList_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']>>;
};

export enum BondFactory_OrderBy {
  BondCount = 'bondCount',
  Bonds = 'bonds',
  Id = 'id',
  IsIssuerAllowListEnabled = 'isIssuerAllowListEnabled',
  IsTokenAllowListEnabled = 'isTokenAllowListEnabled',
  IssuerAllowList = 'issuerAllowList',
  TokenAllowList = 'tokenAllowList'
}

export enum BondState {
  Active = 'active',
  Defaulted = 'defaulted',
  Paid = 'paid',
  PaidEarly = 'paidEarly'
}

export enum BondType {
  Convert = 'convert',
  Simple = 'simple'
}

export type Bond_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountUnpaid?: InputMaybe<Scalars['BigInt']>;
  amountUnpaid_gt?: InputMaybe<Scalars['BigInt']>;
  amountUnpaid_gte?: InputMaybe<Scalars['BigInt']>;
  amountUnpaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amountUnpaid_lt?: InputMaybe<Scalars['BigInt']>;
  amountUnpaid_lte?: InputMaybe<Scalars['BigInt']>;
  amountUnpaid_not?: InputMaybe<Scalars['BigInt']>;
  amountUnpaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<Bond_Filter>>>;
  auctions_?: InputMaybe<Auction_Filter>;
  clearingPrice?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_gt?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_gte?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  clearingPrice_lt?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_lte?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_not?: InputMaybe<Scalars['BigDecimal']>;
  clearingPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  collateralRatio?: InputMaybe<Scalars['BigInt']>;
  collateralRatio_gt?: InputMaybe<Scalars['BigInt']>;
  collateralRatio_gte?: InputMaybe<Scalars['BigInt']>;
  collateralRatio_in?: InputMaybe<Array<Scalars['BigInt']>>;
  collateralRatio_lt?: InputMaybe<Scalars['BigInt']>;
  collateralRatio_lte?: InputMaybe<Scalars['BigInt']>;
  collateralRatio_not?: InputMaybe<Scalars['BigInt']>;
  collateralRatio_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  collateralToken?: InputMaybe<Scalars['String']>;
  collateralTokenAmount?: InputMaybe<Scalars['BigInt']>;
  collateralTokenAmount_gt?: InputMaybe<Scalars['BigInt']>;
  collateralTokenAmount_gte?: InputMaybe<Scalars['BigInt']>;
  collateralTokenAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  collateralTokenAmount_lt?: InputMaybe<Scalars['BigInt']>;
  collateralTokenAmount_lte?: InputMaybe<Scalars['BigInt']>;
  collateralTokenAmount_not?: InputMaybe<Scalars['BigInt']>;
  collateralTokenAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  collateralToken_?: InputMaybe<Token_Filter>;
  collateralToken_contains?: InputMaybe<Scalars['String']>;
  collateralToken_contains_nocase?: InputMaybe<Scalars['String']>;
  collateralToken_ends_with?: InputMaybe<Scalars['String']>;
  collateralToken_ends_with_nocase?: InputMaybe<Scalars['String']>;
  collateralToken_gt?: InputMaybe<Scalars['String']>;
  collateralToken_gte?: InputMaybe<Scalars['String']>;
  collateralToken_in?: InputMaybe<Array<Scalars['String']>>;
  collateralToken_lt?: InputMaybe<Scalars['String']>;
  collateralToken_lte?: InputMaybe<Scalars['String']>;
  collateralToken_not?: InputMaybe<Scalars['String']>;
  collateralToken_not_contains?: InputMaybe<Scalars['String']>;
  collateralToken_not_contains_nocase?: InputMaybe<Scalars['String']>;
  collateralToken_not_ends_with?: InputMaybe<Scalars['String']>;
  collateralToken_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  collateralToken_not_in?: InputMaybe<Array<Scalars['String']>>;
  collateralToken_not_starts_with?: InputMaybe<Scalars['String']>;
  collateralToken_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  collateralToken_starts_with?: InputMaybe<Scalars['String']>;
  collateralToken_starts_with_nocase?: InputMaybe<Scalars['String']>;
  convertibleRatio?: InputMaybe<Scalars['BigInt']>;
  convertibleRatio_gt?: InputMaybe<Scalars['BigInt']>;
  convertibleRatio_gte?: InputMaybe<Scalars['BigInt']>;
  convertibleRatio_in?: InputMaybe<Array<Scalars['BigInt']>>;
  convertibleRatio_lt?: InputMaybe<Scalars['BigInt']>;
  convertibleRatio_lte?: InputMaybe<Scalars['BigInt']>;
  convertibleRatio_not?: InputMaybe<Scalars['BigInt']>;
  convertibleRatio_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  convertibleTokenAmount?: InputMaybe<Scalars['BigInt']>;
  convertibleTokenAmount_gt?: InputMaybe<Scalars['BigInt']>;
  convertibleTokenAmount_gte?: InputMaybe<Scalars['BigInt']>;
  convertibleTokenAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  convertibleTokenAmount_lt?: InputMaybe<Scalars['BigInt']>;
  convertibleTokenAmount_lte?: InputMaybe<Scalars['BigInt']>;
  convertibleTokenAmount_not?: InputMaybe<Scalars['BigInt']>;
  convertibleTokenAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  createdAt?: InputMaybe<Scalars['BigInt']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  decimals?: InputMaybe<Scalars['Int']>;
  decimals_gt?: InputMaybe<Scalars['Int']>;
  decimals_gte?: InputMaybe<Scalars['Int']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']>>;
  decimals_lt?: InputMaybe<Scalars['Int']>;
  decimals_lte?: InputMaybe<Scalars['Int']>;
  decimals_not?: InputMaybe<Scalars['Int']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  maturityDate?: InputMaybe<Scalars['BigInt']>;
  maturityDate_gt?: InputMaybe<Scalars['BigInt']>;
  maturityDate_gte?: InputMaybe<Scalars['BigInt']>;
  maturityDate_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maturityDate_lt?: InputMaybe<Scalars['BigInt']>;
  maturityDate_lte?: InputMaybe<Scalars['BigInt']>;
  maturityDate_not?: InputMaybe<Scalars['BigInt']>;
  maturityDate_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxSupply?: InputMaybe<Scalars['BigInt']>;
  maxSupply_gt?: InputMaybe<Scalars['BigInt']>;
  maxSupply_gte?: InputMaybe<Scalars['BigInt']>;
  maxSupply_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxSupply_lt?: InputMaybe<Scalars['BigInt']>;
  maxSupply_lte?: InputMaybe<Scalars['BigInt']>;
  maxSupply_not?: InputMaybe<Scalars['BigInt']>;
  maxSupply_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<InputMaybe<Bond_Filter>>>;
  owner?: InputMaybe<Scalars['Bytes']>;
  owner_contains?: InputMaybe<Scalars['Bytes']>;
  owner_gt?: InputMaybe<Scalars['Bytes']>;
  owner_gte?: InputMaybe<Scalars['Bytes']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']>>;
  owner_lt?: InputMaybe<Scalars['Bytes']>;
  owner_lte?: InputMaybe<Scalars['Bytes']>;
  owner_not?: InputMaybe<Scalars['Bytes']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  paymentToken?: InputMaybe<Scalars['String']>;
  paymentToken_?: InputMaybe<Token_Filter>;
  paymentToken_contains?: InputMaybe<Scalars['String']>;
  paymentToken_contains_nocase?: InputMaybe<Scalars['String']>;
  paymentToken_ends_with?: InputMaybe<Scalars['String']>;
  paymentToken_ends_with_nocase?: InputMaybe<Scalars['String']>;
  paymentToken_gt?: InputMaybe<Scalars['String']>;
  paymentToken_gte?: InputMaybe<Scalars['String']>;
  paymentToken_in?: InputMaybe<Array<Scalars['String']>>;
  paymentToken_lt?: InputMaybe<Scalars['String']>;
  paymentToken_lte?: InputMaybe<Scalars['String']>;
  paymentToken_not?: InputMaybe<Scalars['String']>;
  paymentToken_not_contains?: InputMaybe<Scalars['String']>;
  paymentToken_not_contains_nocase?: InputMaybe<Scalars['String']>;
  paymentToken_not_ends_with?: InputMaybe<Scalars['String']>;
  paymentToken_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  paymentToken_not_in?: InputMaybe<Array<Scalars['String']>>;
  paymentToken_not_starts_with?: InputMaybe<Scalars['String']>;
  paymentToken_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  paymentToken_starts_with?: InputMaybe<Scalars['String']>;
  paymentToken_starts_with_nocase?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<BondState>;
  state_in?: InputMaybe<Array<BondState>>;
  state_not?: InputMaybe<BondState>;
  state_not_in?: InputMaybe<Array<BondState>>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_gt?: InputMaybe<Scalars['String']>;
  symbol_gte?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_lt?: InputMaybe<Scalars['String']>;
  symbol_lte?: InputMaybe<Scalars['String']>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']>;
  tokenBalances_?: InputMaybe<TokenBalance_Filter>;
  type?: InputMaybe<BondType>;
  type_in?: InputMaybe<Array<BondType>>;
  type_not?: InputMaybe<BondType>;
  type_not_in?: InputMaybe<Array<BondType>>;
};

export enum Bond_OrderBy {
  AmountUnpaid = 'amountUnpaid',
  Auctions = 'auctions',
  ClearingPrice = 'clearingPrice',
  CollateralRatio = 'collateralRatio',
  CollateralToken = 'collateralToken',
  CollateralTokenAmount = 'collateralTokenAmount',
  CollateralTokenDecimals = 'collateralToken__decimals',
  CollateralTokenId = 'collateralToken__id',
  CollateralTokenName = 'collateralToken__name',
  CollateralTokenSymbol = 'collateralToken__symbol',
  ConvertibleRatio = 'convertibleRatio',
  ConvertibleTokenAmount = 'convertibleTokenAmount',
  CreatedAt = 'createdAt',
  Decimals = 'decimals',
  Id = 'id',
  MaturityDate = 'maturityDate',
  MaxSupply = 'maxSupply',
  Name = 'name',
  Owner = 'owner',
  PaymentToken = 'paymentToken',
  PaymentTokenDecimals = 'paymentToken__decimals',
  PaymentTokenId = 'paymentToken__id',
  PaymentTokenName = 'paymentToken__name',
  PaymentTokenSymbol = 'paymentToken__symbol',
  State = 'state',
  Symbol = 'symbol',
  TokenBalances = 'tokenBalances',
  Type = 'type'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Query = {
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  account?: Maybe<Account>;
  accounts: Array<Account>;
  auction?: Maybe<Auction>;
  auctions: Array<Auction>;
  bid?: Maybe<Bid>;
  bids: Array<Bid>;
  bond?: Maybe<Bond>;
  bondFactories: Array<BondFactory>;
  bondFactory?: Maybe<BondFactory>;
  bonds: Array<Bond>;
  token?: Maybe<Token>;
  tokenBalance?: Maybe<TokenBalance>;
  tokenBalances: Array<TokenBalance>;
  tokens: Array<Token>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryAccountArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAccountsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Account_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Account_Filter>;
};


export type QueryAuctionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAuctionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Auction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Auction_Filter>;
};


export type QueryBidArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBidsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Bid_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bid_Filter>;
};


export type QueryBondArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBondFactoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BondFactory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BondFactory_Filter>;
};


export type QueryBondFactoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBondsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Bond_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bond_Filter>;
};


export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokenBalanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokenBalancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TokenBalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TokenBalance_Filter>;
};


export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};

export type Subscription = {
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  account?: Maybe<Account>;
  accounts: Array<Account>;
  auction?: Maybe<Auction>;
  auctions: Array<Auction>;
  bid?: Maybe<Bid>;
  bids: Array<Bid>;
  bond?: Maybe<Bond>;
  bondFactories: Array<BondFactory>;
  bondFactory?: Maybe<BondFactory>;
  bonds: Array<Bond>;
  token?: Maybe<Token>;
  tokenBalance?: Maybe<TokenBalance>;
  tokenBalances: Array<TokenBalance>;
  tokens: Array<Token>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionAccountArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAccountsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Account_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Account_Filter>;
};


export type SubscriptionAuctionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAuctionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Auction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Auction_Filter>;
};


export type SubscriptionBidArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionBidsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Bid_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bid_Filter>;
};


export type SubscriptionBondArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionBondFactoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BondFactory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BondFactory_Filter>;
};


export type SubscriptionBondFactoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionBondsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Bond_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bond_Filter>;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokenBalanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokenBalancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TokenBalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TokenBalance_Filter>;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};

/**
 * An ERC20 token
 *
 */
export type Token = {
  /** ERC20 token decimals */
  decimals: Scalars['Int'];
  /** Address of the token */
  id: Scalars['ID'];
  /** ERC20 token name */
  name: Scalars['String'];
  /** ERC20 token symbol */
  symbol: Scalars['String'];
};

/**
 * A amount of bonds transferred between accounts
 *
 */
export type TokenBalance = {
  /** Account involved in the transfer */
  account: Account;
  /** Amount of bonds held by the account */
  amount: Scalars['BigInt'];
  /** The bond being transferred */
  bond: Bond;
  /** Concatenation of userId and bondId */
  id: Scalars['ID'];
};

export type TokenBalance_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']>;
  account_contains_nocase?: InputMaybe<Scalars['String']>;
  account_ends_with?: InputMaybe<Scalars['String']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']>;
  account_gt?: InputMaybe<Scalars['String']>;
  account_gte?: InputMaybe<Scalars['String']>;
  account_in?: InputMaybe<Array<Scalars['String']>>;
  account_lt?: InputMaybe<Scalars['String']>;
  account_lte?: InputMaybe<Scalars['String']>;
  account_not?: InputMaybe<Scalars['String']>;
  account_not_contains?: InputMaybe<Scalars['String']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']>;
  account_not_ends_with?: InputMaybe<Scalars['String']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  account_not_in?: InputMaybe<Array<Scalars['String']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  account_starts_with?: InputMaybe<Scalars['String']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<TokenBalance_Filter>>>;
  bond?: InputMaybe<Scalars['String']>;
  bond_?: InputMaybe<Bond_Filter>;
  bond_contains?: InputMaybe<Scalars['String']>;
  bond_contains_nocase?: InputMaybe<Scalars['String']>;
  bond_ends_with?: InputMaybe<Scalars['String']>;
  bond_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bond_gt?: InputMaybe<Scalars['String']>;
  bond_gte?: InputMaybe<Scalars['String']>;
  bond_in?: InputMaybe<Array<Scalars['String']>>;
  bond_lt?: InputMaybe<Scalars['String']>;
  bond_lte?: InputMaybe<Scalars['String']>;
  bond_not?: InputMaybe<Scalars['String']>;
  bond_not_contains?: InputMaybe<Scalars['String']>;
  bond_not_contains_nocase?: InputMaybe<Scalars['String']>;
  bond_not_ends_with?: InputMaybe<Scalars['String']>;
  bond_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bond_not_in?: InputMaybe<Array<Scalars['String']>>;
  bond_not_starts_with?: InputMaybe<Scalars['String']>;
  bond_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bond_starts_with?: InputMaybe<Scalars['String']>;
  bond_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<TokenBalance_Filter>>>;
};

export enum TokenBalance_OrderBy {
  Account = 'account',
  AccountId = 'account__id',
  AccountUserid = 'account__userid',
  Amount = 'amount',
  Bond = 'bond',
  BondAmountUnpaid = 'bond__amountUnpaid',
  BondClearingPrice = 'bond__clearingPrice',
  BondCollateralRatio = 'bond__collateralRatio',
  BondCollateralTokenAmount = 'bond__collateralTokenAmount',
  BondConvertibleRatio = 'bond__convertibleRatio',
  BondConvertibleTokenAmount = 'bond__convertibleTokenAmount',
  BondCreatedAt = 'bond__createdAt',
  BondDecimals = 'bond__decimals',
  BondId = 'bond__id',
  BondMaturityDate = 'bond__maturityDate',
  BondMaxSupply = 'bond__maxSupply',
  BondName = 'bond__name',
  BondOwner = 'bond__owner',
  BondState = 'bond__state',
  BondSymbol = 'bond__symbol',
  BondType = 'bond__type',
  Id = 'id'
}

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  decimals?: InputMaybe<Scalars['Int']>;
  decimals_gt?: InputMaybe<Scalars['Int']>;
  decimals_gte?: InputMaybe<Scalars['Int']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']>>;
  decimals_lt?: InputMaybe<Scalars['Int']>;
  decimals_lte?: InputMaybe<Scalars['Int']>;
  decimals_not?: InputMaybe<Scalars['Int']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_gt?: InputMaybe<Scalars['String']>;
  symbol_gte?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_lt?: InputMaybe<Scalars['String']>;
  symbol_lte?: InputMaybe<Scalars['String']>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum Token_OrderBy {
  Decimals = 'decimals',
  Id = 'id',
  Name = 'name',
  Symbol = 'symbol'
}

export type _Block_ = {
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type SingleAuctionQueryVariables = Exact<{
  auctionId: Scalars['ID'];
}>;


export type SingleAuctionQuery = { auction?: { id: string, orderCancellationEndDate: any, start: any, end: any, bondsSold: any, totalPaid?: any | null, offeringSize: any, totalBidVolume: any, minimumFundingThreshold: any, minimumBidSize: any, minimumBondPrice: any, live: boolean, clearingPrice?: any | null, bond: { id: string, name: string, symbol: string, decimals: number, owner: any, maturityDate: any, collateralRatio: any, convertibleRatio: any, maxSupply: any, state: BondState, type: BondType, paymentToken: { id: string, symbol: string }, collateralToken: { id: string, symbol: string, name: string } }, bidding: { name: string, id: string, symbol: string, decimals: number } } | null };

export type AllAuctionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAuctionsQuery = { auctions: Array<{ id: string, orderCancellationEndDate: any, offeringSize: any, minimumBondPrice: any, end: any, live: boolean, clearingPrice?: any | null, bond: { type: BondType, id: string, name: string, state: BondState, symbol: string, maturityDate: any, paymentToken: { id: string, name: string, symbol: string, decimals: number }, collateralToken: { id: string, name: string, symbol: string, decimals: number } }, bidding: { id: string, decimals: number, symbol: string, name: string } }> };

export type BidsForSingleAuctionQueryVariables = Exact<{
  auctionId: Scalars['Int'];
}>;


export type BidsForSingleAuctionQuery = { bids: Array<{ id: string, timestamp: any, canceltx?: any | null, claimtx?: any | null, createtx: any, payable: any, size: any, bytes: string, auction: number }> };

export type SingleBondQueryVariables = Exact<{
  bondId: Scalars['ID'];
  accountId: Scalars['String'];
}>;


export type SingleBondQuery = { bond?: { id: string, name: string, maxSupply: any, amountUnpaid: any, state: BondState, symbol: string, type: BondType, owner: any, maturityDate: any, createdAt: any, collateralRatio: any, collateralTokenAmount: any, convertibleTokenAmount: any, decimals: number, convertibleRatio: any, clearingPrice?: any | null, paymentToken: { id: string, symbol: string, name: string, decimals: number }, collateralToken: { id: string, symbol: string, name: string, decimals: number }, tokenBalances: Array<{ amount: any }>, auctions: Array<{ end: any }> } | null };

export type AllBondsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBondsQuery = { bonds: Array<{ state: BondState, amountUnpaid: any, id: string, createdAt: any, name: string, symbol: string, decimals: number, type: BondType, owner: any, maturityDate: any, collateralRatio: any, convertibleRatio: any, maxSupply: any, paymentToken: { id: string, symbol: string, name: string, decimals: number }, tokenBalances: Array<{ amount: any }>, collateralToken: { id: string, symbol: string, name: string, decimals: number } }> };

export type MaturityDateForAuctionQueryVariables = Exact<{
  auctionId: Scalars['ID'];
}>;


export type MaturityDateForAuctionQuery = { auction?: { end: any, bond: { maturityDate: any } } | null };

export type AccountDetailsQueryVariables = Exact<{
  account: Scalars['ID'];
}>;


export type AccountDetailsQuery = { account?: { tokenBalances?: Array<{ amount: any, bond: { id: string, state: BondState, name: string, symbol: string, decimals: number, type: BondType, owner: any, maturityDate: any, collateralRatio: any, convertibleRatio: any, maxSupply: any, clearingPrice?: any | null, paymentToken: { id: string, decimals: number, symbol: string }, collateralToken: { id: string, decimals: number, symbol: string }, auctions: Array<{ end: any }> } }> | null } | null };

export type BidsForAccountNoCancelledQueryVariables = Exact<{
  account: Scalars['String'];
  auctionId: Scalars['Int'];
}>;


export type BidsForAccountNoCancelledQuery = { bids: Array<{ id: string, bytes: string }> };

export type BidsForAccountQueryVariables = Exact<{
  account: Scalars['String'];
  auctionId: Scalars['Int'];
}>;


export type BidsForAccountQuery = { bids: Array<{ id: string, timestamp: any, canceltx?: any | null, claimtx?: any | null, createtx: any, payable: any, size: any, bytes: string, auction: number }> };

export type TokenAllowListQueryVariables = Exact<{ [key: string]: never; }>;


export type TokenAllowListQuery = { bondFactories: Array<{ id: string, tokenAllowList?: Array<any> | null }> };


export const SingleAuctionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleAuction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderCancellationEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"bond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"maturityDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralRatio"}},{"kind":"Field","name":{"kind":"Name","value":"convertibleRatio"}},{"kind":"Field","name":{"kind":"Name","value":"maxSupply"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bidding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"bondsSold"}},{"kind":"Field","name":{"kind":"Name","value":"totalPaid"}},{"kind":"Field","name":{"kind":"Name","value":"offeringSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidVolume"}},{"kind":"Field","name":{"kind":"Name","value":"minimumFundingThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"minimumBidSize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumBondPrice"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"clearingPrice"}}]}}]}}]} as unknown as DocumentNode<SingleAuctionQuery, SingleAuctionQueryVariables>;
export const AllAuctionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAuctions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auctions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"end"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderCancellationEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"offeringSize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumBondPrice"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"clearingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"bond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"collateralToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maturityDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bidding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllAuctionsQuery, AllAuctionsQueryVariables>;
export const BidsForSingleAuctionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BidsForSingleAuction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bids"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canceltx"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"canceltx"}},{"kind":"Field","name":{"kind":"Name","value":"claimtx"}},{"kind":"Field","name":{"kind":"Name","value":"createtx"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"bytes"}},{"kind":"Field","name":{"kind":"Name","value":"auction"}}]}}]}}]} as unknown as DocumentNode<BidsForSingleAuctionQuery, BidsForSingleAuctionQueryVariables>;
export const SingleBondDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleBond"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bondId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bond"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bondId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"maxSupply"}},{"kind":"Field","name":{"kind":"Name","value":"amountUnpaid"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"maturityDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"collateralRatio"}},{"kind":"Field","name":{"kind":"Name","value":"collateralTokenAmount"}},{"kind":"Field","name":{"kind":"Name","value":"convertibleTokenAmount"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"paymentToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokenBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auctions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"convertibleRatio"}},{"kind":"Field","name":{"kind":"Name","value":"clearingPrice"}}]}}]}}]} as unknown as DocumentNode<SingleBondQuery, SingleBondQueryVariables>;
export const AllBondsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllBonds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bonds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"amountUnpaid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"maturityDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokenBalances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralRatio"}},{"kind":"Field","name":{"kind":"Name","value":"convertibleRatio"}},{"kind":"Field","name":{"kind":"Name","value":"maxSupply"}}]}}]}}]} as unknown as DocumentNode<AllBondsQuery, AllBondsQueryVariables>;
export const MaturityDateForAuctionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaturityDateForAuction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"bond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturityDate"}}]}}]}}]}}]} as unknown as DocumentNode<MaturityDateForAuctionQuery, MaturityDateForAuctionQueryVariables>;
export const AccountDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenBalances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"bond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"maturityDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateralRatio"}},{"kind":"Field","name":{"kind":"Name","value":"convertibleRatio"}},{"kind":"Field","name":{"kind":"Name","value":"maxSupply"}},{"kind":"Field","name":{"kind":"Name","value":"clearingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"auctions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountDetailsQuery, AccountDetailsQueryVariables>;
export const BidsForAccountNoCancelledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BidsForAccountNoCancelled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bids"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"auction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canceltx"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bytes"}}]}}]}}]} as unknown as DocumentNode<BidsForAccountNoCancelledQuery, BidsForAccountNoCancelledQueryVariables>;
export const BidsForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BidsForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bids"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"auction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auctionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"canceltx"}},{"kind":"Field","name":{"kind":"Name","value":"claimtx"}},{"kind":"Field","name":{"kind":"Name","value":"createtx"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"bytes"}},{"kind":"Field","name":{"kind":"Name","value":"auction"}}]}}]}}]} as unknown as DocumentNode<BidsForAccountQuery, BidsForAccountQueryVariables>;
export const TokenAllowListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TokenAllowList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bondFactories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tokenAllowList"}}]}}]}}]} as unknown as DocumentNode<TokenAllowListQuery, TokenAllowListQueryVariables>;